import { Heading, Modal, ModalProps, Divider, Text } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { useTranslation } from 'next-i18next'
import { useConsumerSizes } from '../../../utils/responsive'

const I18N_NAMESPACE = ['account']

interface ApplePayLearnMoreModalProps {
  browserSupported: boolean
}

const ApplePayLearnMoreModal: FunctionComponent<ApplePayLearnMoreModalProps & Omit<ModalProps, 'children'>> = (
  props: ApplePayLearnMoreModalProps & Omit<ModalProps, 'children'>
) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { sectionHeadingSize, textSize } = useConsumerSizes()

  const handleClose = (): void => {
    // @ts-ignore: OPERATION BLEED STOPPER
    props.onClose()
  }

  return (
    <Modal {...props} onClose={handleClose} onBackdropClick={handleClose} onEscapeKeyDown={handleClose}>
      <Modal.Header>
        <div className='text-center'>
          <Heading size={sectionHeadingSize} testNameSpace='modal'>
            Apple Pay
          </Heading>
        </div>
      </Modal.Header>

      <Divider kind={'Hairline'} />
      <Modal.Content>
        <Text size={textSize}>{t('account:tab:payment-methods:applePay:learnMoreModal:body1')}</Text>
        <br />
        <Text size={textSize}>{t('account:tab:payment-methods:applePay:learnMoreModal:body2')}</Text>
        <br />
        {!props.browserSupported && (
          <>
            <Text size={textSize} bold>
              {t('account:tab:payment-methods:applePay:learnMoreModal:warning-header')}
            </Text>
            <Text size={textSize}>{t('account:tab:payment-methods:applePay:learnMoreModal:warning-body')}</Text>
          </>
        )}
      </Modal.Content>
    </Modal>
  )
}

export default ApplePayLearnMoreModal
